import api from '@/store/api'
import { getField, updateField } from 'vuex-map-fields'

const state = {
	subscriptions: {
		data: [],
		last_page: 0,
		total: 0,
		to: 0,
		from: 0
	},
	filter: {
		keyword: '',
		page: 1,
		count: 10,
		sort_by: '',
		theme_filter: []
	},
	form: {
		name: '',
		price: '',
		currency: '',
		duration: ''
	},
	errors: {
		name: '',
		price: '',
		currency: '',
		duration: ''
	},
	isLoading: false
}

const mutations = {
	updateField
}

const actions = {
	async list ({ state }, payload) {
		state.isLoading = true
		const { data, status } = await api('get', `subscription-list${payload}`)

		if (status) {
			state.subscriptions.data = data.data.data
			state.filter.page = data.data.current_page
			state.subscriptions.last_page = data.data.last_page
			state.subscriptions.total = data.data.total
			state.subscriptions.to = data.data.to
			state.subscriptions.from = data.data.from
			state.filter.count = Number(data.data.per_page)
		} else {
			state.songs = []
		}
		state.isLoading = false
	},

	async create ({ state }, payload) {

	}
}

const getters = {
	getField,
	subscriptionList: state => state.subscriptions,
	isLoading: state => state.isLoading
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
